import { FC, PropsWithChildren } from 'react';
import { useFetchAllData } from 'src/redesign/shared/hooks/useFetchAllData';

export const Bootstrap: FC<PropsWithChildren<unknown>> = ({ children }) => {
  useFetchAllData();

  return <>{children}</>;
};
